const ProfilePicturePlaceholderSrc =
  "/assets/profile/profilePicturePlaceholder.svg";

export default ProfilePicturePlaceholderSrc;
